import { styled } from 'styled-components';

export const HEADER_HEIGHT = '3.5rem';

export const StyledHeader = styled.header`
  position: fixed;
  z-index: 103;
  top: 0;
  width: 100vw;
  height: ${HEADER_HEIGHT};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.sizing.large};
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  box-shadow: ${({ theme }) => theme.effects.dropShadow.uber};
  left: 2.5rem;
  padding-left: ${({ theme }) => theme.sizing.xlarge};

  ${({ theme }) => theme.mqFrom('lg')} {
    height: ${HEADER_HEIGHT};
  }
  a {
    background-color: ${({ theme }) => theme.colours.brand.main};
    flex: 0 0 187px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  // shows a separator line when context filters are visible below
  &:has(+ .core > .sub-header-container) {
    box-shadow: none;
    border-bottom: 1px solid
      ${({ theme }) => theme.colours.canvas.secondary.main};
  }
`;
